export enum BaseReportTypeEnums {
    PrincipalReports = 1,
    LPCPrincipalReports = 100,
    DepositReports = 2,
    DepositoryYearEndSummaries = 3,
    ReimbursementReports = 5,
    PayrollItemizationReports = 6,
    OtherPeriodicReports = 8,
    SubvendorReports = 7,
    LateContributionReports = 11,
    IEPACReports = 301,
    IEPACPeriodicReports = 302,
    DonationReports = 201
  }
